/**
 * Determine whether a location has usable coordinates or a placeId.
 * @param {{ lat?: any, lng?: any, placeId?: any }} loc
 * @returns {boolean}
 */
const hasLocation = (loc) => {
	if (!loc) return false;
	const lat = Number.parseFloat(loc.lat);
	const lng = Number.parseFloat(loc.lng);
	const hasLatLng = Number.isFinite(lat) && Number.isFinite(lng);
	const hasPlace = !!(loc.placeId && `${loc.placeId}`.trim());
	return hasLatLng || hasPlace;
};

export default hasLocation;
